import directives from './module';

directives.directive('toggleProjectModal', $compile => {
        return {
            restrict: 'A',
            terminal: true,
            priority: 1000,
            scope: false,
            link(scope: any, element: ng.IAugmentedJQuery) {
                if (!scope.project) scope.project = scope.$ctrl.project;

                element.attr('ng-href', '/project/{{::project.id}}');
                element.attr('ng-click', '$root.projectModalSvc.toggleProjectModal(project, $event)');

                element.removeAttr('toggle-project-modal');

                $compile(element)(scope);
            }
        };
    }
);

directives.directive('projectModalLink', () => {
        return {
            scope: false,
            restrict: 'E',
            template: `<a class="project-name p-info"
                          toggle-project-modal
                          title="{{::(project.name || $ctrl.project.name)}}">
                        {{::(project.name || $ctrl.project.name)}}
                      </a>`
        };
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/toggleProjectModalDirective.ts